import { $tenant } from '@msdk/common'
import { Markdown, styled } from '@msdk/ui'
import { useRecoilValue } from 'recoil'

import { NotificationLink } from './NotificationLink'

export interface Props {
  body: string | undefined
}

const SyledMessage = styled('div')`
  margin: 0;
  p {
    margin: 0;
  }
  white-space: pre-wrap;
`

export function NotificationMarkdown({ body }: Props) {
  const tenant = useRecoilValue($tenant)

  return (
    <SyledMessage>
      <Markdown
        componentsOverrides={{
          a({ children, href }) {
            return (
              <NotificationLink href={href} tenant={tenant}>
                {children}
              </NotificationLink>
            )
          },
        }}
      >
        {body ?? ''}
      </Markdown>
    </SyledMessage>
  )
}
